import React from 'react';
import classNames from 'classnames';
import { ButtonNext } from 'pure-react-carousel';
import { ArrowNextIcon } from '../../icons';
import css from './ListingCardsCarousel.css';

const CarouselButtonNext = ({
    show = true,
    renderContent = null,
    hideOnStartEnd = false,
    className = null,
}) => {
    const rootClassNames = classNames(css.sliderButton, css.sliderButtonNext, className);
    if (typeof renderContent === 'function') {
        return renderContent({ rootClassNames });
    }

    if (!show) return null;

    return (
        <ButtonNext
            className={classNames(rootClassNames, {
                [css.hideOnStartEnd]: hideOnStartEnd,
            })}
        >
            <ArrowNextIcon />
        </ButtonNext>
    );
};

export default CarouselButtonNext;
